import { useState } from 'react'
import { translations } from '../../../../configs/translations'
import { Language } from '../../../../context/LanguageContext'
import { formatDate } from '../../../../utils/formatDate'
import { formatTextWithParams } from '../../../../utils/formatTextWithParams'
import './Achievement.css'

interface AchievementProps {
    image: string
    title: string
    description: string
    rarity: number
    progress: number
    dateTimeGot: string | null
}

export const Achievement = ({ image, title, description, rarity, progress, dateTimeGot }: AchievementProps) => {
    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const titleId = "achievements_" + title as keyof typeof translations.ru
    const descriptionId = "achievements_" + description as keyof typeof translations.ru

    return (
        <div className='achievement'>
            <div className='achievement-content-wrapper'>
                <div className='achievement-image'>
                    <img src={'/achievements/' + image + ".png"} alt={image} />
                </div>

                <div className='achievement-content'>
                    <h1>{t[titleId]}</h1>
                    <p>{t[descriptionId]}</p>
                    <p>{formatTextWithParams(t.achievements_x_percent_has_achievement, [rarity.toFixed(2) + '%'])}</p>
                </div>

                <div className='achievement-progress'>
                    <p>
                        {dateTimeGot ?
                            formatTextWithParams(t.achievements_earned_at, [
                                formatDate(new Date(dateTimeGot), { withHours: true })
                            ]) :
                            progress.toFixed(2) + "%"}
                    </p>
                </div>
            </div>

            <div className='achievement-progress-fill-wrapper' style={{ width: progress + '%' }}>
                <div className='achievement-progress-fill'></div>
            </div>
        </div>
    )
}